/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  AdHocJobStatus,
  AnalyzeSectionSimilarity200,
  AnalyzeSectionSimilarityBody,
  BadRequestResponse,
  Chat,
  ConflictResponse,
  CreateCategoryFromCategory200,
  CreateCategoryFromCategoryBody,
  CreateCategoryFromItem200,
  CreateCategoryFromItemBody,
  CreateCategoryFromSections200,
  CreateCategoryFromSectionsBody,
  CreateChatBody,
  CreateChatParams,
  CreateSectionFromPage200,
  CreateSectionFromPageBody,
  DefineDoclistCategoryFromPages200,
  DeleteDoclistCategory200,
  DeleteDoclistCategoryBody,
  DeleteDoclistSection200,
  DeleteDoclistSectionBody,
  DeleteDoclistSections200,
  DeleteDoclistSectionsBody,
  DeleteSectionPage200,
  DeleteSectionPageBody,
  DeleteSectionPages200,
  DeleteSectionPagesBody,
  ExportAsyncChatDoclist202,
  ExportAsyncChatDoclistBody,
  ExportAsyncChatDoclistDocx202,
  ExportAsyncChatDoclistDocxBody,
  ExtractSectionPages201,
  ExtractSectionPagesBody,
  ExtractSectionPagesToNewCategory201,
  ExtractSectionPagesToNewCategoryBody,
  ForbiddenResponse,
  FormatSummary200,
  FormatSummary404,
  FormatSummaryBody,
  GenerateChatTitle200,
  GetChatQuestions200,
  GetDoclist200,
  GetDoclistParams,
  GetSummary200,
  GetSummaryParams,
  GetTerms200,
  GetUniversalSummary200,
  GetUniversalSummary404,
  GetUniversalSummaryBody,
  InternalServerErrorResponse,
  ListChats200,
  MergeAllCategorySections200,
  MergeAllCategorySectionsBody,
  MergeChatDoclistSections200,
  MergeChatDoclistSectionsBody,
  MergeSectionsMultiple200,
  MergeSectionsMultipleBody,
  NotFoundResponse,
  PopulateBulkDoclistPages202,
  PopulateBulkDoclistPagesBody,
  RecreateChat201,
  RecreateChatBody,
  RedefineDoclistCategoryFromPages200,
  RegenerateSectionTitle200,
  RegenerateSectionTitleBody,
  RegenerateSectionTitlesMultiple200,
  RegenerateSectionTitlesMultipleBody,
  RenameDoclistCategory200,
  RenameDoclistCategoryBody,
  RenameDoclistSection200,
  RenameDoclistSectionBody,
  ReorderChatDoclistCategories200,
  ReorderChatDoclistCategories400,
  ReorderChatDoclistCategoriesBody,
  ReorderChatDoclistPages200,
  ReorderChatDoclistPagesBody,
  ReorderChatDoclistSections200,
  ReorderChatDoclistSections400,
  ReorderChatDoclistSectionsBody,
  ReorderSectionsMultiple200,
  ReorderSectionsMultiple400,
  ReorderSectionsMultipleBody,
  RotateSectionPage200,
  RotateSectionPageBody,
  RotateSectionPages200,
  RotateSectionPagesBody,
  SortCategorySections200,
  SortCategorySectionsBody,
  SplitDoclistSection200,
  SplitDoclistSectionBody,
  StreamChatMessageBody,
  UnauthorizedResponse,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List past chat conversations for the current user in a project
 */
export const listChats = (
  organizationId: string,
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ListChats200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chats`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getListChatsQueryKey = (
  organizationId: string,
  projectId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chats`,
  ] as const;
};

export const getListChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof listChats>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListChatsQueryKey(organizationId, projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listChats>>> = ({
    signal,
  }) => listChats(organizationId, projectId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listChats>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listChats>>
>;
export type ListChatsQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useListChats<
  TData = Awaited<ReturnType<typeof listChats>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChats>>,
          TError,
          Awaited<ReturnType<typeof listChats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListChats<
  TData = Awaited<ReturnType<typeof listChats>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChats>>,
          TError,
          Awaited<ReturnType<typeof listChats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListChats<
  TData = Awaited<ReturnType<typeof listChats>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List past chat conversations for the current user in a project
 */

export function useListChats<
  TData = Awaited<ReturnType<typeof listChats>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListChatsQueryOptions(
    organizationId,
    projectId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate an AI-powered title for a chat conversation
 */
export const generateChatTitle = (
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GenerateChatTitle200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/generate-title`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getGenerateChatTitleMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateChatTitle>>,
    TError,
    { organizationId: string; projectId: string; chatId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateChatTitle>>,
  TError,
  { organizationId: string; projectId: string; chatId: string },
  TContext
> => {
  const mutationKey = ["generateChatTitle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateChatTitle>>,
    { organizationId: string; projectId: string; chatId: string }
  > = (props) => {
    const { organizationId, projectId, chatId } = props ?? {};

    return generateChatTitle(organizationId, projectId, chatId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateChatTitleMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateChatTitle>>
>;

export type GenerateChatTitleMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Generate an AI-powered title for a chat conversation
 */
export const useGenerateChatTitle = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateChatTitle>>,
      TError,
      { organizationId: string; projectId: string; chatId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof generateChatTitle>>,
  TError,
  { organizationId: string; projectId: string; chatId: string },
  TContext
> => {
  return useMutation(getGenerateChatTitleMutationOptions(options), queryClient);
};
/**
 * @summary Create a new chat for a collection of documents
 */
export const createChat = (
  organizationId: string,
  projectId: string,
  createChatBody: CreateChatBody,
  params?: CreateChatParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Chat>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createChatBody,
      params,
      signal,
    },
    options
  );
};

export const getCreateChatMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChat>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: CreateChatBody;
      params?: CreateChatParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChat>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateChatBody;
    params?: CreateChatParams;
  },
  TContext
> => {
  const mutationKey = ["createChat"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChat>>,
    {
      organizationId: string;
      projectId: string;
      data: CreateChatBody;
      params?: CreateChatParams;
    }
  > = (props) => {
    const { organizationId, projectId, data, params } = props ?? {};

    return createChat(organizationId, projectId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChat>>
>;
export type CreateChatMutationBody = CreateChatBody;
export type CreateChatMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a new chat for a collection of documents
 */
export const useCreateChat = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createChat>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: CreateChatBody;
        params?: CreateChatParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createChat>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateChatBody;
    params?: CreateChatParams;
  },
  TContext
> => {
  return useMutation(getCreateChatMutationOptions(options), queryClient);
};
/**
 * @summary Get chat
 */
export const getChat = (
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Chat>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetChatQueryKey = (
  organizationId: string,
  projectId: string,
  chatId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}`,
  ] as const;
};

export const getGetChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getChat>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetChatQueryKey(organizationId, projectId, chatId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChat>>> = ({
    signal,
  }) => getChat(organizationId, projectId, chatId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && chatId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChat>>
>;
export type GetChatQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChat>>,
          TError,
          Awaited<ReturnType<typeof getChat>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChat>>,
          TError,
          Awaited<ReturnType<typeof getChat>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get chat
 */

export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetChatQueryOptions(
    organizationId,
    projectId,
    chatId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sends a message to the chat and streams the AI response using Server-Sent Events (SSE).
The response is streamed as a series of events including message_start, delta, and message_end.

 * @summary Stream a chat message using SSE
 */
export const streamChatMessage = (
  organizationId: string,
  projectId: string,
  chatId: string,
  streamChatMessageBody: StreamChatMessageBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<string>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/stream`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: streamChatMessageBody,
      signal,
    },
    options
  );
};

export const getStreamChatMessageMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof streamChatMessage>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: StreamChatMessageBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof streamChatMessage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: StreamChatMessageBody;
  },
  TContext
> => {
  const mutationKey = ["streamChatMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof streamChatMessage>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: StreamChatMessageBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return streamChatMessage(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type StreamChatMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof streamChatMessage>>
>;
export type StreamChatMessageMutationBody = StreamChatMessageBody;
export type StreamChatMessageMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Stream a chat message using SSE
 */
export const useStreamChatMessage = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof streamChatMessage>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: StreamChatMessageBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof streamChatMessage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: StreamChatMessageBody;
  },
  TContext
> => {
  return useMutation(getStreamChatMessageMutationOptions(options), queryClient);
};
/**
 * Returns the current status of an async ad-hoc extraction job started
from chat. Terminal (completed/failed) statuses are served from the
DB; non-terminal statuses are proxied to sky-custom-reports and
promoted to the DB on first observation of completion or failure.

 * @summary Poll the status of an async ad-hoc extraction job
 */
export const getAdHocReportStatus = (
  organizationId: string,
  projectId: string,
  chatId: string,
  jobId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AdHocJobStatus>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/ad-hoc-jobs/${jobId}/status`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetAdHocReportStatusQueryKey = (
  organizationId: string,
  projectId: string,
  chatId: string,
  jobId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/ad-hoc-jobs/${jobId}/status`,
  ] as const;
};

export const getGetAdHocReportStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdHocReportStatus>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdHocReportStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdHocReportStatusQueryKey(organizationId, projectId, chatId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdHocReportStatus>>
  > = ({ signal }) =>
    getAdHocReportStatus(
      organizationId,
      projectId,
      chatId,
      jobId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && chatId && jobId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdHocReportStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdHocReportStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdHocReportStatus>>
>;
export type GetAdHocReportStatusQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetAdHocReportStatus<
  TData = Awaited<ReturnType<typeof getAdHocReportStatus>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdHocReportStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdHocReportStatus>>,
          TError,
          Awaited<ReturnType<typeof getAdHocReportStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdHocReportStatus<
  TData = Awaited<ReturnType<typeof getAdHocReportStatus>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdHocReportStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdHocReportStatus>>,
          TError,
          Awaited<ReturnType<typeof getAdHocReportStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdHocReportStatus<
  TData = Awaited<ReturnType<typeof getAdHocReportStatus>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdHocReportStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Poll the status of an async ad-hoc extraction job
 */

export function useGetAdHocReportStatus<
  TData = Awaited<ReturnType<typeof getAdHocReportStatus>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdHocReportStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdHocReportStatusQueryOptions(
    organizationId,
    projectId,
    chatId,
    jobId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get project summary or snapshot
 */
export const getSummary = (
  organizationId: string,
  projectId: string,
  chatId: string,
  params?: GetSummaryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetSummary200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/summary`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetSummaryQueryKey = (
  organizationId: string,
  projectId: string,
  chatId: string,
  params?: GetSummaryParams
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSummaryQueryKey(organizationId, projectId, chatId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummary>>> = ({
    signal,
  }) =>
    getSummary(
      organizationId,
      projectId,
      chatId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && chatId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSummary>>
>;
export type GetSummaryQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  params: undefined | GetSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummary>>,
          TError,
          Awaited<ReturnType<typeof getSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummary>>,
          TError,
          Awaited<ReturnType<typeof getSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get project summary or snapshot
 */

export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSummaryQueryOptions(
    organizationId,
    projectId,
    chatId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get combined terms from summary and snapshot
 */
export const getTerms = (
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetTerms200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/terms`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetTermsQueryKey = (
  organizationId: string,
  projectId: string,
  chatId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/terms`,
  ] as const;
};

export const getGetTermsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTerms>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTermsQueryKey(organizationId, projectId, chatId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTerms>>> = ({
    signal,
  }) => getTerms(organizationId, projectId, chatId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && chatId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTermsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTerms>>
>;
export type GetTermsQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetTerms<
  TData = Awaited<ReturnType<typeof getTerms>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTerms>>,
          TError,
          Awaited<ReturnType<typeof getTerms>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTerms<
  TData = Awaited<ReturnType<typeof getTerms>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTerms>>,
          TError,
          Awaited<ReturnType<typeof getTerms>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTerms<
  TData = Awaited<ReturnType<typeof getTerms>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get combined terms from summary and snapshot
 */

export function useGetTerms<
  TData = Awaited<ReturnType<typeof getTerms>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTermsQueryOptions(
    organizationId,
    projectId,
    chatId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get doclist for a chat
 */
export const getDoclist = (
  organizationId: string,
  projectId: string,
  params?: GetDoclistParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetDoclist200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetDoclistQueryKey = (
  organizationId: string,
  projectId: string,
  params?: GetDoclistParams
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDoclistQueryOptions = <
  TData = Awaited<ReturnType<typeof getDoclist>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  params?: GetDoclistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDoclistQueryKey(organizationId, projectId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDoclist>>> = ({
    signal,
  }) => getDoclist(organizationId, projectId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDoclist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDoclistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDoclist>>
>;
export type GetDoclistQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetDoclist<
  TData = Awaited<ReturnType<typeof getDoclist>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  params: undefined | GetDoclistParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDoclist>>,
          TError,
          Awaited<ReturnType<typeof getDoclist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDoclist<
  TData = Awaited<ReturnType<typeof getDoclist>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  params?: GetDoclistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDoclist>>,
          TError,
          Awaited<ReturnType<typeof getDoclist>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDoclist<
  TData = Awaited<ReturnType<typeof getDoclist>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  params?: GetDoclistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get doclist for a chat
 */

export function useGetDoclist<
  TData = Awaited<ReturnType<typeof getDoclist>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  params?: GetDoclistParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDoclist>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDoclistQueryOptions(
    organizationId,
    projectId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get suggested questions for the chat
 */
export const getChatQuestions = (
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetChatQuestions200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/questions`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetChatQuestionsQueryKey = (
  organizationId: string,
  projectId: string,
  chatId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/questions`,
  ] as const;
};

export const getGetChatQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatQuestions>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetChatQuestionsQueryKey(organizationId, projectId, chatId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChatQuestions>>
  > = ({ signal }) =>
    getChatQuestions(organizationId, projectId, chatId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId && chatId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetChatQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatQuestions>>
>;
export type GetChatQuestionsQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetChatQuestions<
  TData = Awaited<ReturnType<typeof getChatQuestions>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatQuestions>>,
          TError,
          Awaited<ReturnType<typeof getChatQuestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatQuestions<
  TData = Awaited<ReturnType<typeof getChatQuestions>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatQuestions>>,
          TError,
          Awaited<ReturnType<typeof getChatQuestions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatQuestions<
  TData = Awaited<ReturnType<typeof getChatQuestions>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get suggested questions for the chat
 */

export function useGetChatQuestions<
  TData = Awaited<ReturnType<typeof getChatQuestions>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  chatId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatQuestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetChatQuestionsQueryOptions(
    organizationId,
    projectId,
    chatId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Reorder sections in a chat's doclist
 */
export const reorderChatDoclistSections = (
  organizationId: string,
  projectId: string,
  reorderChatDoclistSectionsBody: ReorderChatDoclistSectionsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReorderChatDoclistSections200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/sections/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: reorderChatDoclistSectionsBody,
      signal,
    },
    options
  );
};

export const getReorderChatDoclistSectionsMutationOptions = <
  TError =
    | ReorderChatDoclistSections400
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderChatDoclistSections>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: ReorderChatDoclistSectionsBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderChatDoclistSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: ReorderChatDoclistSectionsBody;
  },
  TContext
> => {
  const mutationKey = ["reorderChatDoclistSections"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderChatDoclistSections>>,
    {
      organizationId: string;
      projectId: string;
      data: ReorderChatDoclistSectionsBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return reorderChatDoclistSections(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderChatDoclistSectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderChatDoclistSections>>
>;
export type ReorderChatDoclistSectionsMutationBody =
  ReorderChatDoclistSectionsBody;
export type ReorderChatDoclistSectionsMutationError =
  | ReorderChatDoclistSections400
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Reorder sections in a chat's doclist
 */
export const useReorderChatDoclistSections = <
  TError =
    | ReorderChatDoclistSections400
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderChatDoclistSections>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: ReorderChatDoclistSectionsBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderChatDoclistSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: ReorderChatDoclistSectionsBody;
  },
  TContext
> => {
  return useMutation(
    getReorderChatDoclistSectionsMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Reorder multiple sections in a chat's doclist
 */
export const reorderSectionsMultiple = (
  organizationId: string,
  projectId: string,
  reorderSectionsMultipleBody: ReorderSectionsMultipleBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReorderSectionsMultiple200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/sections/reorder/multiple`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: reorderSectionsMultipleBody,
      signal,
    },
    options
  );
};

export const getReorderSectionsMultipleMutationOptions = <
  TError =
    | ReorderSectionsMultiple400
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderSectionsMultiple>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: ReorderSectionsMultipleBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderSectionsMultiple>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: ReorderSectionsMultipleBody;
  },
  TContext
> => {
  const mutationKey = ["reorderSectionsMultiple"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderSectionsMultiple>>,
    {
      organizationId: string;
      projectId: string;
      data: ReorderSectionsMultipleBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return reorderSectionsMultiple(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderSectionsMultipleMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderSectionsMultiple>>
>;
export type ReorderSectionsMultipleMutationBody = ReorderSectionsMultipleBody;
export type ReorderSectionsMultipleMutationError =
  | ReorderSectionsMultiple400
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Reorder multiple sections in a chat's doclist
 */
export const useReorderSectionsMultiple = <
  TError =
    | ReorderSectionsMultiple400
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderSectionsMultiple>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: ReorderSectionsMultipleBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderSectionsMultiple>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: ReorderSectionsMultipleBody;
  },
  TContext
> => {
  return useMutation(
    getReorderSectionsMultipleMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Reorder categories in a chat's doclist
 */
export const reorderChatDoclistCategories = (
  organizationId: string,
  projectId: string,
  reorderChatDoclistCategoriesBody: ReorderChatDoclistCategoriesBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReorderChatDoclistCategories200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: reorderChatDoclistCategoriesBody,
      signal,
    },
    options
  );
};

export const getReorderChatDoclistCategoriesMutationOptions = <
  TError =
    | ReorderChatDoclistCategories400
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderChatDoclistCategories>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: ReorderChatDoclistCategoriesBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderChatDoclistCategories>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: ReorderChatDoclistCategoriesBody;
  },
  TContext
> => {
  const mutationKey = ["reorderChatDoclistCategories"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderChatDoclistCategories>>,
    {
      organizationId: string;
      projectId: string;
      data: ReorderChatDoclistCategoriesBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return reorderChatDoclistCategories(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderChatDoclistCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderChatDoclistCategories>>
>;
export type ReorderChatDoclistCategoriesMutationBody =
  ReorderChatDoclistCategoriesBody;
export type ReorderChatDoclistCategoriesMutationError =
  | ReorderChatDoclistCategories400
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Reorder categories in a chat's doclist
 */
export const useReorderChatDoclistCategories = <
  TError =
    | ReorderChatDoclistCategories400
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderChatDoclistCategories>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: ReorderChatDoclistCategoriesBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderChatDoclistCategories>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: ReorderChatDoclistCategoriesBody;
  },
  TContext
> => {
  return useMutation(
    getReorderChatDoclistCategoriesMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Reorder pages in a chat's doclist
 */
export const reorderChatDoclistPages = (
  organizationId: string,
  projectId: string,
  chatId: string,
  reorderChatDoclistPagesBody: ReorderChatDoclistPagesBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReorderChatDoclistPages200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/pages/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: reorderChatDoclistPagesBody,
      signal,
    },
    options
  );
};

export const getReorderChatDoclistPagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderChatDoclistPages>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ReorderChatDoclistPagesBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderChatDoclistPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ReorderChatDoclistPagesBody;
  },
  TContext
> => {
  const mutationKey = ["reorderChatDoclistPages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderChatDoclistPages>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ReorderChatDoclistPagesBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return reorderChatDoclistPages(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderChatDoclistPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderChatDoclistPages>>
>;
export type ReorderChatDoclistPagesMutationBody = ReorderChatDoclistPagesBody;
export type ReorderChatDoclistPagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Reorder pages in a chat's doclist
 */
export const useReorderChatDoclistPages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderChatDoclistPages>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: ReorderChatDoclistPagesBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reorderChatDoclistPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ReorderChatDoclistPagesBody;
  },
  TContext
> => {
  return useMutation(
    getReorderChatDoclistPagesMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Recreate a chat from an existing chat
 */
export const recreateChat = (
  organizationId: string,
  projectId: string,
  recreateChatBody: RecreateChatBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RecreateChat201>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/recreate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: recreateChatBody,
      signal,
    },
    options
  );
};

export const getRecreateChatMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recreateChat>>,
    TError,
    { organizationId: string; projectId: string; data: RecreateChatBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recreateChat>>,
  TError,
  { organizationId: string; projectId: string; data: RecreateChatBody },
  TContext
> => {
  const mutationKey = ["recreateChat"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recreateChat>>,
    { organizationId: string; projectId: string; data: RecreateChatBody }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return recreateChat(organizationId, projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecreateChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof recreateChat>>
>;
export type RecreateChatMutationBody = RecreateChatBody;
export type RecreateChatMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Recreate a chat from an existing chat
 */
export const useRecreateChat = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recreateChat>>,
      TError,
      { organizationId: string; projectId: string; data: RecreateChatBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof recreateChat>>,
  TError,
  { organizationId: string; projectId: string; data: RecreateChatBody },
  TContext
> => {
  return useMutation(getRecreateChatMutationOptions(options), queryClient);
};
/**
 * @summary Asynchronously export doclist to a document format
 */
export const exportAsyncChatDoclist = (
  organizationId: string,
  projectId: string,
  chatId: string,
  exportAsyncChatDoclistBody: ExportAsyncChatDoclistBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ExportAsyncChatDoclist202>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/export/async`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: exportAsyncChatDoclistBody,
      signal,
    },
    options
  );
};

export const getExportAsyncChatDoclistMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAsyncChatDoclist>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExportAsyncChatDoclistBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAsyncChatDoclist>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExportAsyncChatDoclistBody;
  },
  TContext
> => {
  const mutationKey = ["exportAsyncChatDoclist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAsyncChatDoclist>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExportAsyncChatDoclistBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return exportAsyncChatDoclist(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAsyncChatDoclistMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAsyncChatDoclist>>
>;
export type ExportAsyncChatDoclistMutationBody = ExportAsyncChatDoclistBody;
export type ExportAsyncChatDoclistMutationError = unknown;

/**
 * @summary Asynchronously export doclist to a document format
 */
export const useExportAsyncChatDoclist = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof exportAsyncChatDoclist>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: ExportAsyncChatDoclistBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof exportAsyncChatDoclist>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExportAsyncChatDoclistBody;
  },
  TContext
> => {
  return useMutation(
    getExportAsyncChatDoclistMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Asynchronously export doclist to a DOCX document format
 */
export const exportAsyncChatDoclistDocx = (
  organizationId: string,
  projectId: string,
  chatId: string,
  exportAsyncChatDoclistDocxBody: ExportAsyncChatDoclistDocxBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ExportAsyncChatDoclistDocx202>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/export-docx/async`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: exportAsyncChatDoclistDocxBody,
      signal,
    },
    options
  );
};

export const getExportAsyncChatDoclistDocxMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAsyncChatDoclistDocx>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExportAsyncChatDoclistDocxBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAsyncChatDoclistDocx>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExportAsyncChatDoclistDocxBody;
  },
  TContext
> => {
  const mutationKey = ["exportAsyncChatDoclistDocx"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAsyncChatDoclistDocx>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExportAsyncChatDoclistDocxBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return exportAsyncChatDoclistDocx(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAsyncChatDoclistDocxMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAsyncChatDoclistDocx>>
>;
export type ExportAsyncChatDoclistDocxMutationBody =
  ExportAsyncChatDoclistDocxBody;
export type ExportAsyncChatDoclistDocxMutationError = unknown;

/**
 * @summary Asynchronously export doclist to a DOCX document format
 */
export const useExportAsyncChatDoclistDocx = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof exportAsyncChatDoclistDocx>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: ExportAsyncChatDoclistDocxBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof exportAsyncChatDoclistDocx>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExportAsyncChatDoclistDocxBody;
  },
  TContext
> => {
  return useMutation(
    getExportAsyncChatDoclistDocxMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Rotate a section page
 */
export const rotateSectionPage = (
  organizationId: string,
  projectId: string,
  sectionId: string,
  pageId: string,
  rotateSectionPageBody: RotateSectionPageBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RotateSectionPage200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/sections/${sectionId}/pages/${pageId}/rotate`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: rotateSectionPageBody,
      signal,
    },
    options
  );
};

export const getRotateSectionPageMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateSectionPage>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      sectionId: string;
      pageId: string;
      data: RotateSectionPageBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rotateSectionPage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    sectionId: string;
    pageId: string;
    data: RotateSectionPageBody;
  },
  TContext
> => {
  const mutationKey = ["rotateSectionPage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rotateSectionPage>>,
    {
      organizationId: string;
      projectId: string;
      sectionId: string;
      pageId: string;
      data: RotateSectionPageBody;
    }
  > = (props) => {
    const { organizationId, projectId, sectionId, pageId, data } = props ?? {};

    return rotateSectionPage(
      organizationId,
      projectId,
      sectionId,
      pageId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RotateSectionPageMutationResult = NonNullable<
  Awaited<ReturnType<typeof rotateSectionPage>>
>;
export type RotateSectionPageMutationBody = RotateSectionPageBody;
export type RotateSectionPageMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Rotate a section page
 */
export const useRotateSectionPage = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rotateSectionPage>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        sectionId: string;
        pageId: string;
        data: RotateSectionPageBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof rotateSectionPage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    sectionId: string;
    pageId: string;
    data: RotateSectionPageBody;
  },
  TContext
> => {
  return useMutation(getRotateSectionPageMutationOptions(options), queryClient);
};
/**
 * @summary Mark a section page as deleted
 */
export const deleteSectionPage = (
  organizationId: string,
  projectId: string,
  chatId: string,
  sectionId: string,
  pageId: string,
  deleteSectionPageBody: DeleteSectionPageBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeleteSectionPage200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/sections/${sectionId}/pages/${pageId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: deleteSectionPageBody,
      signal,
    },
    options
  );
};

export const getDeleteSectionPageMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSectionPage>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      pageId: string;
      data: DeleteSectionPageBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSectionPage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    pageId: string;
    data: DeleteSectionPageBody;
  },
  TContext
> => {
  const mutationKey = ["deleteSectionPage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSectionPage>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      pageId: string;
      data: DeleteSectionPageBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, sectionId, pageId, data } =
      props ?? {};

    return deleteSectionPage(
      organizationId,
      projectId,
      chatId,
      sectionId,
      pageId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSectionPageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSectionPage>>
>;
export type DeleteSectionPageMutationBody = DeleteSectionPageBody;
export type DeleteSectionPageMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Mark a section page as deleted
 */
export const useDeleteSectionPage = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSectionPage>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        sectionId: string;
        pageId: string;
        data: DeleteSectionPageBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSectionPage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    pageId: string;
    data: DeleteSectionPageBody;
  },
  TContext
> => {
  return useMutation(getDeleteSectionPageMutationOptions(options), queryClient);
};
/**
 * @summary Rotate multiple section pages
 */
export const rotateSectionPages = (
  organizationId: string,
  projectId: string,
  chatId: string,
  rotateSectionPagesBody: RotateSectionPagesBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RotateSectionPages200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/pages/rotate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rotateSectionPagesBody,
      signal,
    },
    options
  );
};

export const getRotateSectionPagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateSectionPages>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: RotateSectionPagesBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rotateSectionPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: RotateSectionPagesBody;
  },
  TContext
> => {
  const mutationKey = ["rotateSectionPages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rotateSectionPages>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: RotateSectionPagesBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return rotateSectionPages(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RotateSectionPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof rotateSectionPages>>
>;
export type RotateSectionPagesMutationBody = RotateSectionPagesBody;
export type RotateSectionPagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Rotate multiple section pages
 */
export const useRotateSectionPages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rotateSectionPages>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: RotateSectionPagesBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof rotateSectionPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: RotateSectionPagesBody;
  },
  TContext
> => {
  return useMutation(
    getRotateSectionPagesMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Delete multiple section pages
 */
export const deleteSectionPages = (
  organizationId: string,
  projectId: string,
  chatId: string,
  deleteSectionPagesBody: DeleteSectionPagesBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeleteSectionPages200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/pages/delete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deleteSectionPagesBody,
      signal,
    },
    options
  );
};

export const getDeleteSectionPagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSectionPages>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: DeleteSectionPagesBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSectionPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: DeleteSectionPagesBody;
  },
  TContext
> => {
  const mutationKey = ["deleteSectionPages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSectionPages>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: DeleteSectionPagesBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return deleteSectionPages(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSectionPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSectionPages>>
>;
export type DeleteSectionPagesMutationBody = DeleteSectionPagesBody;
export type DeleteSectionPagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Delete multiple section pages
 */
export const useDeleteSectionPages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSectionPages>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: DeleteSectionPagesBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSectionPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: DeleteSectionPagesBody;
  },
  TContext
> => {
  return useMutation(
    getDeleteSectionPagesMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Extract pages to a new section
 */
export const extractSectionPages = (
  organizationId: string,
  projectId: string,
  chatId: string,
  extractSectionPagesBody: ExtractSectionPagesBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ExtractSectionPages201>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/pages/extract`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: extractSectionPagesBody,
      signal,
    },
    options
  );
};

export const getExtractSectionPagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractSectionPages>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExtractSectionPagesBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractSectionPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExtractSectionPagesBody;
  },
  TContext
> => {
  const mutationKey = ["extractSectionPages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractSectionPages>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExtractSectionPagesBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return extractSectionPages(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractSectionPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractSectionPages>>
>;
export type ExtractSectionPagesMutationBody = ExtractSectionPagesBody;
export type ExtractSectionPagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Extract pages to a new section
 */
export const useExtractSectionPages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractSectionPages>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: ExtractSectionPagesBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof extractSectionPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExtractSectionPagesBody;
  },
  TContext
> => {
  return useMutation(
    getExtractSectionPagesMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Extract pages to a new category
 */
export const extractSectionPagesToNewCategory = (
  organizationId: string,
  projectId: string,
  chatId: string,
  extractSectionPagesToNewCategoryBody: ExtractSectionPagesToNewCategoryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ExtractSectionPagesToNewCategory201>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/pages/new-category/extract`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: extractSectionPagesToNewCategoryBody,
      signal,
    },
    options
  );
};

export const getExtractSectionPagesToNewCategoryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractSectionPagesToNewCategory>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExtractSectionPagesToNewCategoryBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractSectionPagesToNewCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExtractSectionPagesToNewCategoryBody;
  },
  TContext
> => {
  const mutationKey = ["extractSectionPagesToNewCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractSectionPagesToNewCategory>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: ExtractSectionPagesToNewCategoryBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return extractSectionPagesToNewCategory(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractSectionPagesToNewCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractSectionPagesToNewCategory>>
>;
export type ExtractSectionPagesToNewCategoryMutationBody =
  ExtractSectionPagesToNewCategoryBody;
export type ExtractSectionPagesToNewCategoryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Extract pages to a new category
 */
export const useExtractSectionPagesToNewCategory = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractSectionPagesToNewCategory>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: ExtractSectionPagesToNewCategoryBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof extractSectionPagesToNewCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: ExtractSectionPagesToNewCategoryBody;
  },
  TContext
> => {
  return useMutation(
    getExtractSectionPagesToNewCategoryMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Mark all section pages as deleted
 */
export const deleteDoclistSection = (
  organizationId: string,
  projectId: string,
  chatId: string,
  sectionId: string,
  deleteDoclistSectionBody: DeleteDoclistSectionBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeleteDoclistSection200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/${sectionId}/delete`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: deleteDoclistSectionBody,
      signal,
    },
    options
  );
};

export const getDeleteDoclistSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDoclistSection>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      data: DeleteDoclistSectionBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDoclistSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    data: DeleteDoclistSectionBody;
  },
  TContext
> => {
  const mutationKey = ["deleteDoclistSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDoclistSection>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      data: DeleteDoclistSectionBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, sectionId, data } = props ?? {};

    return deleteDoclistSection(
      organizationId,
      projectId,
      chatId,
      sectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDoclistSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDoclistSection>>
>;
export type DeleteDoclistSectionMutationBody = DeleteDoclistSectionBody;
export type DeleteDoclistSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Mark all section pages as deleted
 */
export const useDeleteDoclistSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDoclistSection>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        sectionId: string;
        data: DeleteDoclistSectionBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDoclistSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    data: DeleteDoclistSectionBody;
  },
  TContext
> => {
  return useMutation(
    getDeleteDoclistSectionMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Mark all section pages as deleted for multiple sections
 */
export const deleteDoclistSections = (
  organizationId: string,
  projectId: string,
  chatId: string,
  deleteDoclistSectionsBody: DeleteDoclistSectionsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeleteDoclistSections200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/delete`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: deleteDoclistSectionsBody,
      signal,
    },
    options
  );
};

export const getDeleteDoclistSectionsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDoclistSections>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: DeleteDoclistSectionsBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDoclistSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: DeleteDoclistSectionsBody;
  },
  TContext
> => {
  const mutationKey = ["deleteDoclistSections"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDoclistSections>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: DeleteDoclistSectionsBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return deleteDoclistSections(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDoclistSectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDoclistSections>>
>;
export type DeleteDoclistSectionsMutationBody = DeleteDoclistSectionsBody;
export type DeleteDoclistSectionsMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Mark all section pages as deleted for multiple sections
 */
export const useDeleteDoclistSections = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDoclistSections>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: DeleteDoclistSectionsBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDoclistSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: DeleteDoclistSectionsBody;
  },
  TContext
> => {
  return useMutation(
    getDeleteDoclistSectionsMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Populate URLs for multiple doclist pages
 */
export const populateBulkDoclistPages = (
  organizationId: string,
  projectId: string,
  chatId: string,
  populateBulkDoclistPagesBody: PopulateBulkDoclistPagesBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PopulateBulkDoclistPages202>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/pages`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: populateBulkDoclistPagesBody,
      signal,
    },
    options
  );
};

export const getPopulateBulkDoclistPagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof populateBulkDoclistPages>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: PopulateBulkDoclistPagesBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof populateBulkDoclistPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: PopulateBulkDoclistPagesBody;
  },
  TContext
> => {
  const mutationKey = ["populateBulkDoclistPages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof populateBulkDoclistPages>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: PopulateBulkDoclistPagesBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return populateBulkDoclistPages(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PopulateBulkDoclistPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof populateBulkDoclistPages>>
>;
export type PopulateBulkDoclistPagesMutationBody = PopulateBulkDoclistPagesBody;
export type PopulateBulkDoclistPagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Populate URLs for multiple doclist pages
 */
export const usePopulateBulkDoclistPages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof populateBulkDoclistPages>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: PopulateBulkDoclistPagesBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof populateBulkDoclistPages>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: PopulateBulkDoclistPagesBody;
  },
  TContext
> => {
  return useMutation(
    getPopulateBulkDoclistPagesMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Creates a new section from an existing page
 */
export const createSectionFromPage = (
  organizationId: string,
  projectId: string,
  chatId: string,
  createSectionFromPageBody: CreateSectionFromPageBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateSectionFromPage200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSectionFromPageBody,
      signal,
    },
    options
  );
};

export const getCreateSectionFromPageMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSectionFromPage>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: CreateSectionFromPageBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSectionFromPage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: CreateSectionFromPageBody;
  },
  TContext
> => {
  const mutationKey = ["createSectionFromPage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSectionFromPage>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: CreateSectionFromPageBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return createSectionFromPage(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSectionFromPageMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSectionFromPage>>
>;
export type CreateSectionFromPageMutationBody = CreateSectionFromPageBody;
export type CreateSectionFromPageMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new section from an existing page
 */
export const useCreateSectionFromPage = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSectionFromPage>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: CreateSectionFromPageBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSectionFromPage>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: CreateSectionFromPageBody;
  },
  TContext
> => {
  return useMutation(
    getCreateSectionFromPageMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Rename a doclist section
 */
export const renameDoclistSection = (
  organizationId: string,
  projectId: string,
  chatId: string,
  sectionId: string,
  renameDoclistSectionBody: RenameDoclistSectionBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RenameDoclistSection200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/${sectionId}/rename`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: renameDoclistSectionBody,
      signal,
    },
    options
  );
};

export const getRenameDoclistSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameDoclistSection>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      data: RenameDoclistSectionBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameDoclistSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    data: RenameDoclistSectionBody;
  },
  TContext
> => {
  const mutationKey = ["renameDoclistSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameDoclistSection>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      data: RenameDoclistSectionBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, sectionId, data } = props ?? {};

    return renameDoclistSection(
      organizationId,
      projectId,
      chatId,
      sectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameDoclistSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameDoclistSection>>
>;
export type RenameDoclistSectionMutationBody = RenameDoclistSectionBody;
export type RenameDoclistSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Rename a doclist section
 */
export const useRenameDoclistSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameDoclistSection>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        sectionId: string;
        data: RenameDoclistSectionBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof renameDoclistSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    data: RenameDoclistSectionBody;
  },
  TContext
> => {
  return useMutation(
    getRenameDoclistSectionMutationOptions(options),
    queryClient
  );
};
/**
 * Triggers the section-title lambda to regenerate the title based on the section's current content
 * @summary Regenerate AI-generated title for a section
 */
export const regenerateSectionTitle = (
  organizationId: string,
  projectId: string,
  chatId: string,
  sectionId: string,
  regenerateSectionTitleBody: RegenerateSectionTitleBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RegenerateSectionTitle200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/${sectionId}/regenerate-title`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: regenerateSectionTitleBody,
      signal,
    },
    options
  );
};

export const getRegenerateSectionTitleMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSectionTitle>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      data: RegenerateSectionTitleBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateSectionTitle>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    data: RegenerateSectionTitleBody;
  },
  TContext
> => {
  const mutationKey = ["regenerateSectionTitle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateSectionTitle>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      sectionId: string;
      data: RegenerateSectionTitleBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, sectionId, data } = props ?? {};

    return regenerateSectionTitle(
      organizationId,
      projectId,
      chatId,
      sectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateSectionTitleMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateSectionTitle>>
>;
export type RegenerateSectionTitleMutationBody = RegenerateSectionTitleBody;
export type RegenerateSectionTitleMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Regenerate AI-generated title for a section
 */
export const useRegenerateSectionTitle = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateSectionTitle>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        sectionId: string;
        data: RegenerateSectionTitleBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateSectionTitle>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    sectionId: string;
    data: RegenerateSectionTitleBody;
  },
  TContext
> => {
  return useMutation(
    getRegenerateSectionTitleMutationOptions(options),
    queryClient
  );
};
/**
 * Triggers parallel AI title generation for multiple sections, significantly faster than calling regenerateSectionTitle sequentially
 * @summary Regenerate AI-generated titles for multiple sections in parallel
 */
export const regenerateSectionTitlesMultiple = (
  organizationId: string,
  projectId: string,
  chatId: string,
  regenerateSectionTitlesMultipleBody: RegenerateSectionTitlesMultipleBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RegenerateSectionTitlesMultiple200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/regenerate-titles`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: regenerateSectionTitlesMultipleBody,
      signal,
    },
    options
  );
};

export const getRegenerateSectionTitlesMultipleMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: RegenerateSectionTitlesMultipleBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: RegenerateSectionTitlesMultipleBody;
  },
  TContext
> => {
  const mutationKey = ["regenerateSectionTitlesMultiple"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: RegenerateSectionTitlesMultipleBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return regenerateSectionTitlesMultiple(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateSectionTitlesMultipleMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>
>;
export type RegenerateSectionTitlesMultipleMutationBody =
  RegenerateSectionTitlesMultipleBody;
export type RegenerateSectionTitlesMultipleMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Regenerate AI-generated titles for multiple sections in parallel
 */
export const useRegenerateSectionTitlesMultiple = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: RegenerateSectionTitlesMultipleBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateSectionTitlesMultiple>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: RegenerateSectionTitlesMultipleBody;
  },
  TContext
> => {
  return useMutation(
    getRegenerateSectionTitlesMultipleMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Rename a doclist category
 */
export const renameDoclistCategory = (
  organizationId: string,
  projectId: string,
  categoryId: number,
  renameDoclistCategoryBody: RenameDoclistCategoryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RenameDoclistCategory200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/${categoryId}/rename`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: renameDoclistCategoryBody,
      signal,
    },
    options
  );
};

export const getRenameDoclistCategoryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameDoclistCategory>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      categoryId: number;
      data: RenameDoclistCategoryBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameDoclistCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    categoryId: number;
    data: RenameDoclistCategoryBody;
  },
  TContext
> => {
  const mutationKey = ["renameDoclistCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameDoclistCategory>>,
    {
      organizationId: string;
      projectId: string;
      categoryId: number;
      data: RenameDoclistCategoryBody;
    }
  > = (props) => {
    const { organizationId, projectId, categoryId, data } = props ?? {};

    return renameDoclistCategory(
      organizationId,
      projectId,
      categoryId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameDoclistCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameDoclistCategory>>
>;
export type RenameDoclistCategoryMutationBody = RenameDoclistCategoryBody;
export type RenameDoclistCategoryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Rename a doclist category
 */
export const useRenameDoclistCategory = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameDoclistCategory>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        categoryId: number;
        data: RenameDoclistCategoryBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof renameDoclistCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    categoryId: number;
    data: RenameDoclistCategoryBody;
  },
  TContext
> => {
  return useMutation(
    getRenameDoclistCategoryMutationOptions(options),
    queryClient
  );
};
/**
 * Loads the section summaries currently grouped under the given FolderCategory, sends them to the `define-category` prompt, and upserts the resulting definition onto the linked `DocumentCategory` (creating and linking one when the folder category has no link yet). Admin-only.

 * @summary Generate and persist an organization-level category definition from the pages of a case doclist category
 */
export const defineDoclistCategoryFromPages = (
  organizationId: string,
  projectId: string,
  categoryId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DefineDoclistCategoryFromPages200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/${categoryId}/define-from-pages`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getDefineDoclistCategoryFromPagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse
    | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof defineDoclistCategoryFromPages>>,
    TError,
    { organizationId: string; projectId: string; categoryId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof defineDoclistCategoryFromPages>>,
  TError,
  { organizationId: string; projectId: string; categoryId: number },
  TContext
> => {
  const mutationKey = ["defineDoclistCategoryFromPages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof defineDoclistCategoryFromPages>>,
    { organizationId: string; projectId: string; categoryId: number }
  > = (props) => {
    const { organizationId, projectId, categoryId } = props ?? {};

    return defineDoclistCategoryFromPages(
      organizationId,
      projectId,
      categoryId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DefineDoclistCategoryFromPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof defineDoclistCategoryFromPages>>
>;

export type DefineDoclistCategoryFromPagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse
  | void;

/**
 * @summary Generate and persist an organization-level category definition from the pages of a case doclist category
 */
export const useDefineDoclistCategoryFromPages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse
    | void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof defineDoclistCategoryFromPages>>,
      TError,
      { organizationId: string; projectId: string; categoryId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof defineDoclistCategoryFromPages>>,
  TError,
  { organizationId: string; projectId: string; categoryId: number },
  TContext
> => {
  return useMutation(
    getDefineDoclistCategoryFromPagesMutationOptions(options),
    queryClient
  );
};
/**
 * Loads the section summaries currently grouped under the given FolderCategory, loads the linked `DocumentCategory`, sends both to the `redefine-category` prompt, and writes the refined definition back to the same `DocumentCategory`. Requires the folder category to already be linked to a DocumentCategory with a non-empty definition. Admin-only.

 * @summary Refine an existing organization-level category definition from the pages of a case doclist category
 */
export const redefineDoclistCategoryFromPages = (
  organizationId: string,
  projectId: string,
  categoryId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RedefineDoclistCategoryFromPages200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/${categoryId}/redefine-from-pages`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getRedefineDoclistCategoryFromPagesMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | void
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redefineDoclistCategoryFromPages>>,
    TError,
    { organizationId: string; projectId: string; categoryId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redefineDoclistCategoryFromPages>>,
  TError,
  { organizationId: string; projectId: string; categoryId: number },
  TContext
> => {
  const mutationKey = ["redefineDoclistCategoryFromPages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redefineDoclistCategoryFromPages>>,
    { organizationId: string; projectId: string; categoryId: number }
  > = (props) => {
    const { organizationId, projectId, categoryId } = props ?? {};

    return redefineDoclistCategoryFromPages(
      organizationId,
      projectId,
      categoryId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RedefineDoclistCategoryFromPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof redefineDoclistCategoryFromPages>>
>;

export type RedefineDoclistCategoryFromPagesMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | void
  | InternalServerErrorResponse;

/**
 * @summary Refine an existing organization-level category definition from the pages of a case doclist category
 */
export const useRedefineDoclistCategoryFromPages = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | void
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof redefineDoclistCategoryFromPages>>,
      TError,
      { organizationId: string; projectId: string; categoryId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof redefineDoclistCategoryFromPages>>,
  TError,
  { organizationId: string; projectId: string; categoryId: number },
  TContext
> => {
  return useMutation(
    getRedefineDoclistCategoryFromPagesMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Creates a new category from an existing section or page
 */
export const createCategoryFromItem = (
  organizationId: string,
  projectId: string,
  createCategoryFromItemBody: CreateCategoryFromItemBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateCategoryFromItem200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCategoryFromItemBody,
      signal,
    },
    options
  );
};

export const getCreateCategoryFromItemMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategoryFromItem>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: CreateCategoryFromItemBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategoryFromItem>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateCategoryFromItemBody;
  },
  TContext
> => {
  const mutationKey = ["createCategoryFromItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategoryFromItem>>,
    {
      organizationId: string;
      projectId: string;
      data: CreateCategoryFromItemBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return createCategoryFromItem(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryFromItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCategoryFromItem>>
>;
export type CreateCategoryFromItemMutationBody = CreateCategoryFromItemBody;
export type CreateCategoryFromItemMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new category from an existing section or page
 */
export const useCreateCategoryFromItem = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCategoryFromItem>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: CreateCategoryFromItemBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCategoryFromItem>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateCategoryFromItemBody;
  },
  TContext
> => {
  return useMutation(
    getCreateCategoryFromItemMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Creates a new category from existing sections
 */
export const createCategoryFromSections = (
  organizationId: string,
  projectId: string,
  createCategoryFromSectionsBody: CreateCategoryFromSectionsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateCategoryFromSections200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/create/multiple`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCategoryFromSectionsBody,
      signal,
    },
    options
  );
};

export const getCreateCategoryFromSectionsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategoryFromSections>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: CreateCategoryFromSectionsBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategoryFromSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateCategoryFromSectionsBody;
  },
  TContext
> => {
  const mutationKey = ["createCategoryFromSections"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategoryFromSections>>,
    {
      organizationId: string;
      projectId: string;
      data: CreateCategoryFromSectionsBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return createCategoryFromSections(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryFromSectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCategoryFromSections>>
>;
export type CreateCategoryFromSectionsMutationBody =
  CreateCategoryFromSectionsBody;
export type CreateCategoryFromSectionsMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new category from existing sections
 */
export const useCreateCategoryFromSections = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCategoryFromSections>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: CreateCategoryFromSectionsBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCategoryFromSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateCategoryFromSectionsBody;
  },
  TContext
> => {
  return useMutation(
    getCreateCategoryFromSectionsMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Creates a new category from an existing category
 */
export const createCategoryFromCategory = (
  organizationId: string,
  projectId: string,
  createCategoryFromCategoryBody: CreateCategoryFromCategoryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateCategoryFromCategory200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/create-from-category`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCategoryFromCategoryBody,
      signal,
    },
    options
  );
};

export const getCreateCategoryFromCategoryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategoryFromCategory>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: CreateCategoryFromCategoryBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategoryFromCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateCategoryFromCategoryBody;
  },
  TContext
> => {
  const mutationKey = ["createCategoryFromCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategoryFromCategory>>,
    {
      organizationId: string;
      projectId: string;
      data: CreateCategoryFromCategoryBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return createCategoryFromCategory(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryFromCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCategoryFromCategory>>
>;
export type CreateCategoryFromCategoryMutationBody =
  CreateCategoryFromCategoryBody;
export type CreateCategoryFromCategoryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new category from an existing category
 */
export const useCreateCategoryFromCategory = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCategoryFromCategory>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: CreateCategoryFromCategoryBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCategoryFromCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: CreateCategoryFromCategoryBody;
  },
  TContext
> => {
  return useMutation(
    getCreateCategoryFromCategoryMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Delete a doclist category
 */
export const deleteDoclistCategory = (
  organizationId: string,
  projectId: string,
  categoryId: number,
  deleteDoclistCategoryBody: DeleteDoclistCategoryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<DeleteDoclistCategory200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/categories/${categoryId}`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: deleteDoclistCategoryBody,
      signal,
    },
    options
  );
};

export const getDeleteDoclistCategoryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDoclistCategory>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      categoryId: number;
      data: DeleteDoclistCategoryBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDoclistCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    categoryId: number;
    data: DeleteDoclistCategoryBody;
  },
  TContext
> => {
  const mutationKey = ["deleteDoclistCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDoclistCategory>>,
    {
      organizationId: string;
      projectId: string;
      categoryId: number;
      data: DeleteDoclistCategoryBody;
    }
  > = (props) => {
    const { organizationId, projectId, categoryId, data } = props ?? {};

    return deleteDoclistCategory(
      organizationId,
      projectId,
      categoryId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDoclistCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDoclistCategory>>
>;
export type DeleteDoclistCategoryMutationBody = DeleteDoclistCategoryBody;
export type DeleteDoclistCategoryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Delete a doclist category
 */
export const useDeleteDoclistCategory = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDoclistCategory>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        categoryId: number;
        data: DeleteDoclistCategoryBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDoclistCategory>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    categoryId: number;
    data: DeleteDoclistCategoryBody;
  },
  TContext
> => {
  return useMutation(
    getDeleteDoclistCategoryMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Merge two sections in a chat's doclist
 */
export const mergeChatDoclistSections = (
  organizationId: string,
  projectId: string,
  chatId: string,
  mergeChatDoclistSectionsBody: MergeChatDoclistSectionsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MergeChatDoclistSections200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/merge`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: mergeChatDoclistSectionsBody,
      signal,
    },
    options
  );
};

export const getMergeChatDoclistSectionsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeChatDoclistSections>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: MergeChatDoclistSectionsBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeChatDoclistSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: MergeChatDoclistSectionsBody;
  },
  TContext
> => {
  const mutationKey = ["mergeChatDoclistSections"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeChatDoclistSections>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: MergeChatDoclistSectionsBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return mergeChatDoclistSections(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeChatDoclistSectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof mergeChatDoclistSections>>
>;
export type MergeChatDoclistSectionsMutationBody = MergeChatDoclistSectionsBody;
export type MergeChatDoclistSectionsMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Merge two sections in a chat's doclist
 */
export const useMergeChatDoclistSections = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mergeChatDoclistSections>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: MergeChatDoclistSectionsBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mergeChatDoclistSections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: MergeChatDoclistSectionsBody;
  },
  TContext
> => {
  return useMutation(
    getMergeChatDoclistSectionsMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Merge multiple sections in a chat's doclist
 */
export const mergeSectionsMultiple = (
  organizationId: string,
  projectId: string,
  chatId: string,
  mergeSectionsMultipleBody: MergeSectionsMultipleBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MergeSectionsMultiple200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/merge/multiple`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: mergeSectionsMultipleBody,
      signal,
    },
    options
  );
};

export const getMergeSectionsMultipleMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeSectionsMultiple>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: MergeSectionsMultipleBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeSectionsMultiple>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: MergeSectionsMultipleBody;
  },
  TContext
> => {
  const mutationKey = ["mergeSectionsMultiple"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeSectionsMultiple>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: MergeSectionsMultipleBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return mergeSectionsMultiple(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeSectionsMultipleMutationResult = NonNullable<
  Awaited<ReturnType<typeof mergeSectionsMultiple>>
>;
export type MergeSectionsMultipleMutationBody = MergeSectionsMultipleBody;
export type MergeSectionsMultipleMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Merge multiple sections in a chat's doclist
 */
export const useMergeSectionsMultiple = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mergeSectionsMultiple>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: MergeSectionsMultipleBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mergeSectionsMultiple>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: MergeSectionsMultipleBody;
  },
  TContext
> => {
  return useMutation(
    getMergeSectionsMultipleMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Merge all sections of a category into a section with a new title
 */
export const mergeAllCategorySections = (
  organizationId: string,
  projectId: string,
  chatId: string,
  mergeAllCategorySectionsBody: MergeAllCategorySectionsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<MergeAllCategorySections200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/categories/merge-all`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: mergeAllCategorySectionsBody,
      signal,
    },
    options
  );
};

export const getMergeAllCategorySectionsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeAllCategorySections>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: MergeAllCategorySectionsBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeAllCategorySections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: MergeAllCategorySectionsBody;
  },
  TContext
> => {
  const mutationKey = ["mergeAllCategorySections"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeAllCategorySections>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: MergeAllCategorySectionsBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return mergeAllCategorySections(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeAllCategorySectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof mergeAllCategorySections>>
>;
export type MergeAllCategorySectionsMutationBody = MergeAllCategorySectionsBody;
export type MergeAllCategorySectionsMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Merge all sections of a category into a section with a new title
 */
export const useMergeAllCategorySections = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mergeAllCategorySections>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: MergeAllCategorySectionsBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof mergeAllCategorySections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: MergeAllCategorySectionsBody;
  },
  TContext
> => {
  return useMutation(
    getMergeAllCategorySectionsMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Split a section into two sections
 */
export const splitDoclistSection = (
  organizationId: string,
  projectId: string,
  chatId: string,
  splitDoclistSectionBody: SplitDoclistSectionBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SplitDoclistSection200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/chat/${chatId}/doclist/sections/split`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: splitDoclistSectionBody,
      signal,
    },
    options
  );
};

export const getSplitDoclistSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof splitDoclistSection>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: SplitDoclistSectionBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof splitDoclistSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: SplitDoclistSectionBody;
  },
  TContext
> => {
  const mutationKey = ["splitDoclistSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof splitDoclistSection>>,
    {
      organizationId: string;
      projectId: string;
      chatId: string;
      data: SplitDoclistSectionBody;
    }
  > = (props) => {
    const { organizationId, projectId, chatId, data } = props ?? {};

    return splitDoclistSection(
      organizationId,
      projectId,
      chatId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SplitDoclistSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof splitDoclistSection>>
>;
export type SplitDoclistSectionMutationBody = SplitDoclistSectionBody;
export type SplitDoclistSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Split a section into two sections
 */
export const useSplitDoclistSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof splitDoclistSection>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        chatId: string;
        data: SplitDoclistSectionBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof splitDoclistSection>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    chatId: string;
    data: SplitDoclistSectionBody;
  },
  TContext
> => {
  return useMutation(
    getSplitDoclistSectionMutationOptions(options),
    queryClient
  );
};
/**
 * Analyzes sections for similarity using hybrid scoring (embeddings + text + structural analysis). Returns groups of similar sections with progress updates via Server-Sent Events.
 * @summary Analyze section similarity using AI-based duplicate detection
 */
export const analyzeSectionSimilarity = (
  organizationId: string,
  projectId: string,
  analyzeSectionSimilarityBody: AnalyzeSectionSimilarityBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<AnalyzeSectionSimilarity200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/sections/analyze-similarity`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: analyzeSectionSimilarityBody,
      signal,
    },
    options
  );
};

export const getAnalyzeSectionSimilarityMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeSectionSimilarity>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: AnalyzeSectionSimilarityBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeSectionSimilarity>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: AnalyzeSectionSimilarityBody;
  },
  TContext
> => {
  const mutationKey = ["analyzeSectionSimilarity"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeSectionSimilarity>>,
    {
      organizationId: string;
      projectId: string;
      data: AnalyzeSectionSimilarityBody;
    }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return analyzeSectionSimilarity(
      organizationId,
      projectId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeSectionSimilarityMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeSectionSimilarity>>
>;
export type AnalyzeSectionSimilarityMutationBody = AnalyzeSectionSimilarityBody;
export type AnalyzeSectionSimilarityMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Analyze section similarity using AI-based duplicate detection
 */
export const useAnalyzeSectionSimilarity = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof analyzeSectionSimilarity>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: AnalyzeSectionSimilarityBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof analyzeSectionSimilarity>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    data: AnalyzeSectionSimilarityBody;
  },
  TContext
> => {
  return useMutation(
    getAnalyzeSectionSimilarityMutationOptions(options),
    queryClient
  );
};
/**
 * Universal summarization endpoint that generates concise 400-800 word AI-powered summaries using Gemini. Supports pages and sections. Uses Redis caching based on content hash to avoid duplicate AI calls.
 * @summary Generate AI-powered summary for pages and sections
 */
export const getUniversalSummary = (
  organizationId: string,
  projectId: string,
  getUniversalSummaryBody: GetUniversalSummaryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetUniversalSummary200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/summary`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getUniversalSummaryBody,
      signal,
    },
    options
  );
};

export const getGetUniversalSummaryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | GetUniversalSummary404
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUniversalSummary>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      data: GetUniversalSummaryBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUniversalSummary>>,
  TError,
  { organizationId: string; projectId: string; data: GetUniversalSummaryBody },
  TContext
> => {
  const mutationKey = ["getUniversalSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUniversalSummary>>,
    { organizationId: string; projectId: string; data: GetUniversalSummaryBody }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return getUniversalSummary(organizationId, projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUniversalSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof getUniversalSummary>>
>;
export type GetUniversalSummaryMutationBody = GetUniversalSummaryBody;
export type GetUniversalSummaryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | GetUniversalSummary404
  | InternalServerErrorResponse;

/**
 * @summary Generate AI-powered summary for pages and sections
 */
export const useGetUniversalSummary = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | GetUniversalSummary404
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getUniversalSummary>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        data: GetUniversalSummaryBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getUniversalSummary>>,
  TError,
  { organizationId: string; projectId: string; data: GetUniversalSummaryBody },
  TContext
> => {
  return useMutation(
    getGetUniversalSummaryMutationOptions(options),
    queryClient
  );
};
/**
 * Reflows the current Summary tab content for a page or section using AI. Accepts a short natural-language instruction (e.g. "Tidy up"). Uses the same prompt and model config as the custom reports Format popover.
 * @summary Format Summary tab content via AI
 */
export const formatSummary = (
  organizationId: string,
  projectId: string,
  formatSummaryBody: FormatSummaryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<FormatSummary200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/summary/format`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: formatSummaryBody,
      signal,
    },
    options
  );
};

export const getFormatSummaryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | FormatSummary404
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof formatSummary>>,
    TError,
    { organizationId: string; projectId: string; data: FormatSummaryBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof formatSummary>>,
  TError,
  { organizationId: string; projectId: string; data: FormatSummaryBody },
  TContext
> => {
  const mutationKey = ["formatSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof formatSummary>>,
    { organizationId: string; projectId: string; data: FormatSummaryBody }
  > = (props) => {
    const { organizationId, projectId, data } = props ?? {};

    return formatSummary(organizationId, projectId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FormatSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof formatSummary>>
>;
export type FormatSummaryMutationBody = FormatSummaryBody;
export type FormatSummaryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | FormatSummary404
  | InternalServerErrorResponse;

/**
 * @summary Format Summary tab content via AI
 */
export const useFormatSummary = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | FormatSummary404
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof formatSummary>>,
      TError,
      { organizationId: string; projectId: string; data: FormatSummaryBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof formatSummary>>,
  TError,
  { organizationId: string; projectId: string; data: FormatSummaryBody },
  TContext
> => {
  return useMutation(getFormatSummaryMutationOptions(options), queryClient);
};
/**
 * @summary Sort sections within a category
 */
export const sortCategorySections = (
  organizationId: string,
  projectId: string,
  categoryId: number,
  sortCategorySectionsBody: SortCategorySectionsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SortCategorySections200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/doclist/category/${categoryId}/sort`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: sortCategorySectionsBody,
      signal,
    },
    options
  );
};

export const getSortCategorySectionsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sortCategorySections>>,
    TError,
    {
      organizationId: string;
      projectId: string;
      categoryId: number;
      data: SortCategorySectionsBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sortCategorySections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    categoryId: number;
    data: SortCategorySectionsBody;
  },
  TContext
> => {
  const mutationKey = ["sortCategorySections"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sortCategorySections>>,
    {
      organizationId: string;
      projectId: string;
      categoryId: number;
      data: SortCategorySectionsBody;
    }
  > = (props) => {
    const { organizationId, projectId, categoryId, data } = props ?? {};

    return sortCategorySections(
      organizationId,
      projectId,
      categoryId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SortCategorySectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof sortCategorySections>>
>;
export type SortCategorySectionsMutationBody = SortCategorySectionsBody;
export type SortCategorySectionsMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ConflictResponse
  | InternalServerErrorResponse;

/**
 * @summary Sort sections within a category
 */
export const useSortCategorySections = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ConflictResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sortCategorySections>>,
      TError,
      {
        organizationId: string;
        projectId: string;
        categoryId: number;
        data: SortCategorySectionsBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sortCategorySections>>,
  TError,
  {
    organizationId: string;
    projectId: string;
    categoryId: number;
    data: SortCategorySectionsBody;
  },
  TContext
> => {
  return useMutation(
    getSortCategorySectionsMutationOptions(options),
    queryClient
  );
};
